<template>
    <div class="content-loader" v-if="isDisplay">
        <div class="ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<style lang="scss">
@import '../scss/Variables.scss';

.content-loader {
    text-align: center;
    padding: 100px 0;

    .ripple {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
        
        div {
            position: absolute;
            border: 4px solid $mainColor;
            opacity: 1;
            @include borderRadius(50%);
            @include animation(ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite);

            &:nth-child(2) {
                @include animationDelay(-0.5s);
            }
        }
    }
}

@keyframes ripple {
    0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
    }
}
</style>

<script>
export default {
    props: {
        isDisplay: Boolean
    }
}
</script>